<template>
  <div :class="['language']">
    <multiselect
      :options="definition.validation.language"
      track-by="value"
      label="value"
      placeholder=""
      selectLabel=""
      deselectLabel=""
      v-model="languageValue"
      :show-labels="false"
      :allow-empty="false"
      :searchable="false"
      @input="valueChanged"
      @open="openValue"
      @close="closeValue"
    >
      <template slot="singleLabel" slot-scope="{ option }">
        {{ option.value }} <span v-if="option.mandatory" class="required">*</span>
      </template>
      <template slot="option" slot-scope="{ option }">
        {{ option.value }} <span v-if="option.mandatory" class="required">*</span>
        <i v-if="getLanguageValue(option.key) !== ''" class="sherpa-icon icon-ico_ok"></i>
      </template>
      <template slot="noResult">

      </template>
      <span v-bind:class="{'active':isOpen==true}" class="arrow" slot="caret"><i class="fa fa-angle-down fa-2x"></i></span>
    </multiselect>
    <div v-if="(isForTranslate() || isForCopy())" class="translate">
      <transition name="fade" mode="out-in">
        <i v-if="isForTranslate() && !translating" class="sherpa-icon icon-translate" @click="translate" v-tooltip="{content: getLang('translate'), delay: { show: 400, hide: 100 }, placement: 'auto'}"></i>
        <i v-else-if="isForCopy() && !translating" class="sherpa-icon icon-copy" @click="copy" v-tooltip="{content: getLang('copyText'), delay: { show: 400, hide: 100 }, placement: 'auto'}"></i>
        <spinner-loading v-else :size="21" class="loading" />
      </transition>
    </div>
  </div>
</template>

<script>
import transport from 'vue-definition-utils/src/utils/transport'
import Multiselect from 'vue-definition-utils/src/utils/multiselect' // 'vue-multiselect ^2.1.6' component with TMD modifications
import language from '../language'

export default {
  name: 'definition-multilanguage',
  props: [
    'definition',
    'object',
    'languageSelected',
    'translating',
    'language',
    'apiparams'
  ],
  data () {
    return {
      languageValue: [],
      isOpen: false
    }
  },
  components: {
    Multiselect
  },
  methods: {
    valueChanged (event) {
      this.$emit('newLanguageSelected', this.languageValue)
    },
    closeValue () {
      this.isOpen = false
    },
    openValue () {
      this.isOpen = true
    },
    getLanguageValue (languageKey) {
      return transport.methods.getLanguageValue(this.object, languageKey)
    },
    translate () {
      this.$emit('translate', this.languageSelected)
    },
    copy () {
      this.$emit('copy', this.languageSelected)
    },
    isForTranslate () {
      return transport.methods.isForTranslate(this.definition, this.apiparams)
    },
    isForCopy () {
      return transport.methods.isForCopy(this.definition)
    },
    getLang (key) {
      return language(this.language, key)
    }
  },
  beforeMount () {
    if (!this.languageSelected) {
      this.languageValue = transport.methods.getFirstMandatoryMultiLanguage(this.definition.validation.language)
      if (this.languageValue === null && this.definition.validation.language && this.definition.validation.language.length > 0) {
        this.languageValue = this.definition.validation.language[0]
      }
      this.$emit('newLanguageSelected', this.languageValue)
    } else {
      this.languageValue = this.languageSelected
    }
  },
  watch: {
    languageSelected (languageSelected) {
      this.languageValue = languageSelected
    }
  }
}
</script>

<style lang="scss">
.language {
  .translate {
    .loading {
      margin-bottom: 10px;

      .vue-simple-spinner {
        margin-top: 0 !important;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.multiselect__tags {
  border: 1px solid #e8e8e8;
  border-radius: 3px;
}
.multiselect__content-wrapper {
  .icon-ico_ok {
    margin-top: 2px;
    float: right;
    color: #b8b8b8;
  }
}
.arrow {
  position: absolute;
  left: 64px;
  top: 7px;
  right: auto;
  color: #ffbd42 !important;
  transition: transform .2s;
  font-size: 11px;
}
.arrow.active {
  -ms-transform: rotate(180deg);
  -webkit-transform: rotate(180deg);
  transform: rotate(180deg);
}
.translate {
  text-align: center;
  margin-left: 2px;
  float: right;
  min-width: 32px;
  line-height: 40px;

  i {
    font-size: 25px;
    cursor: pointer;

    &:before {
      color: #5dbecb;
      transition: all .2s ease-in;
    }

    &:hover {
      &:before {
        color: #4599a4;
      }
    }
  }

  .loading {
    margin-top: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// node_modules/vue-definition/src/components/item/multilanguage.vue